import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND_NAME, CONTACT_EMAIL, HUB_URL, MAILTO_PLAIN } from '../lib/site';

const link =
  'inline-flex items-center min-h-[44px] px-1 text-secondary-300 hover:text-white underline-offset-4 hover:underline rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400';

const Footer: React.FC = () => (
  <footer className="border-t border-secondary-800 bg-secondary-950 pb-[max(1rem,env(safe-area-inset-bottom))] mt-auto">
    <div className="page-inner py-6">
      <div className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
        <div className="min-w-0">
          <Link to="/" aria-label={`${BRAND_NAME} — home`} className="inline-flex items-center gap-2.5 min-h-[44px] rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400">
            <img src="/FinalLogoRebuild.png" alt="" width={28} height={28} className="w-7 h-7 object-contain" />
            <span className="font-semibold text-white">{BRAND_NAME}</span>
          </Link>
          <p className="mt-2 text-sm text-secondary-300">
            Development estimates and managed hosting.{' '}
            <a href={MAILTO_PLAIN} className="text-primary-300 hover:text-primary-200 underline underline-offset-4">
              {CONTACT_EMAIL}
            </a>
          </p>
        </div>
        <nav aria-label="Footer" className="grid grid-cols-2 sm:grid-cols-4 gap-x-6 text-sm">
          <Link to="/pricing" className={link}>Pricing</Link>
          <Link to="/plans" className={link}>Hosting Plans</Link>
          <Link to="/tiers" className={link}>Tier Reference</Link>
          <Link to="/sites" className={link}>Hosted Sites</Link>
          <Link to="/support" className={link}>Support</Link>
          <Link to="/contact" className={link}>Contact</Link>
          <Link to="/tos" className={link}>Terms</Link>
          <Link to="/privacy" className={link}>Privacy</Link>
        </nav>
      </div>
      <div className="mt-3 pt-3 border-t border-secondary-800 flex flex-wrap items-center justify-between gap-2 text-xs text-secondary-400">
        <p>&copy; {new Date().getFullYear()} FairCorp. All rights reserved.</p>
        <a href={HUB_URL} className="inline-flex items-center min-h-[44px] hover:text-white underline-offset-4 hover:underline">
          FairCorp Hub
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
